import React from 'react';
import { ModalBody, ModalFooter, ModalHeader } from '../modal-helpers';
import { modalDescription } from './constants';
import Button from '../../buttons/DeprecatedButton/DeprecatedButton';
import './RefreshAccessTokenErrorModal.scss';
import { useModalActions } from '@mm/state/modules/modalsState/actions';

type Props = {
  callback?: () => void;
};

export default ({ callback }: Props) => {
  const { openPermissionsHelperModal } = useModalActions();
  const onClick = () => {
    openPermissionsHelperModal(callback, 'grant');
  };
  return (
    <div className="refresh-access-token-error-modal">
      <ModalHeader />
      <ModalBody className="refresh-access-token-error-modal__body">
        {modalDescription}
      </ModalBody>
      <ModalFooter>
        <Button invert onClick={onClick}>
          Grant Permissions
        </Button>
      </ModalFooter>
    </div>
  );
};
